import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { GridIcon, ReceiptIcon, AlertIcon, UsersIcon, PackageIcon, BarChartIcon, LogOutIcon, MenuIcon, TrendUpIcon, ZapIcon, WalletIcon, DocumentIcon, CurrencyIcon, CheckIcon } from './Icons';

const NavItem = ({ to, icon, label, badge, badgeDanger, end, onClick }) => (
  <NavLink to={to} end={end} className={({isActive})=>`nav-item${isActive?' active':''}`} onClick={onClick}>
    <span className="nav-icon">{icon}</span>
    {label}
    {badge && <span className="nav-badge" style={badgeDanger?{background:'var(--danger)'}:{}}>{badge}</span>}
  </NavLink>
);

// Verifica se o utilizador tem acesso a um módulo
// permissoes=null significa super admin (acesso total)
const temAcesso = (permissoes, modulo) => {
  if (!permissoes) return true; // super admin
  return permissoes.includes(modulo);
};

export default function SidebarAdmin() {
  const navigate = useNavigate();
  const { utilizador, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  const perm = utilizador?.permissoes || null; // null = super admin

  return (
    <>
      <div className={`sidebar-overlay${open?' show':''}`} onClick={close}/>
      <button className="sidebar-toggle" onClick={()=>setOpen(true)} style={{position:'fixed',top:'13px',left:'12px',zIndex:60}}>
        <MenuIcon size={16}/>
      </button>

      <div className={`sidebar${open?' open':''}`}>
        <div className="sidebar-logo">
          <div className="logo-mark">
            <div className="logo-k">K</div>
            <div>
              <div className="logo-text">KiAluga</div>
              <div className="logo-sub">
                {perm === null ? 'Super Admin' : 'Painel Admin'}
              </div>
            </div>
          </div>
        </div>

        <div className="sidebar-nav">
          <div className="nav-section">Principal</div>

          {temAcesso(perm, 'visao_geral') && (
            <NavItem to="/admin"           icon={<GridIcon size={16}/>}    label="Visão Geral"       end onClick={close}/>
          )}
          {temAcesso(perm, 'dashboard') && (
            <NavItem to="/admin/dashboard" icon={<TrendUpIcon size={16}/>} label="Dashboard Métricas"    onClick={close}/>
          )}
          {temAcesso(perm, 'transacoes') && (
            <NavItem to="/admin/transacoes"   icon={<ReceiptIcon size={16}/>}  label="Transações"    onClick={close}/>
          )}
          {temAcesso(perm, 'disputas') && (
            <NavItem to="/admin/disputas"     icon={<AlertIcon size={16}/>}    label="Disputas"      badge="!" badgeDanger onClick={close}/>
          )}
          {temAcesso(perm, 'utilizadores') && (
            <NavItem to="/admin/utilizadores" icon={<UsersIcon size={16}/>}    label="Utilizadores"  onClick={close}/>
          )}
          {temAcesso(perm, 'anuncios') && (
            <NavItem to="/admin/anuncios"     icon={<PackageIcon size={16}/>}  label="Anúncios"      badge="●" onClick={close}/>
          )}
          {temAcesso(perm, 'financeiro') && (
            <NavItem to="/admin/financeiro"   icon={<BarChartIcon size={16}/>} label="Financeiro"    onClick={close}/>
          )}
          {temAcesso(perm, 'facturas') && (
            <NavItem to="/admin/facturas"     icon={<DocumentIcon size={16}/>} label="Facturas"      onClick={close}/>
          )}
          {temAcesso(perm, 'saldos') && (
            <NavItem to="/admin/saldos"       icon={<WalletIcon size={16}/>}   label="Saldos"        onClick={close}/>
          )}
          {temAcesso(perm, 'publicidade') && (
            <NavItem to="/admin/publicidade"  icon={<ZapIcon size={16}/>}      label="Publicidade"   onClick={close}/>
          )}

          <div className="nav-section">Plataforma</div>
          <NavItem to="/admin/configuracoes"           icon={<ZapIcon size={16}/>}    label="Configurações"          onClick={close}/>
          <NavItem to="/admin/fornecedores-confianca"  icon={<CheckIcon size={16}/>}  label="Fornecedores Verificados" onClick={close}/>

          <div className="nav-section">Sistema</div>
          <div className="nav-item" style={{color:'rgba(239,68,68,0.7)'}} onClick={()=>{logout();navigate('/');}}>
            <span className="nav-icon"><LogOutIcon size={16}/></span> Sair da conta
          </div>
        </div>

        <div className="sidebar-footer">
          <div className="user-card">
            <div className="avatar" style={{background:'var(--danger)',overflow:'hidden'}}>
              {utilizador?.foto_url
                ? <img src={utilizador.foto_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                : (perm === null ? 'SA' : (utilizador?.nome?.[0]?.toUpperCase() || 'AD'))
              }
            </div>
            <div className="user-info">
              <div className="user-name">{utilizador?.nome||'Administrador'}</div>
              <div className="user-role">
                {perm === null ? 'Super administrador' : `Funcionário · ${perm.length} módulo${perm.length!==1?'s':''}`}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
